// In your accountBalanceSlice.js or similar file
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    balance: {
        usdBalance: 0,
        lbpBalance: 0,
    },
    availableSalesAndBalance: {
        availableUsdBalance: 0,
        availableLbpBalance: 0,
    }

};

const accountBalanceSlice = createSlice({
    name: 'accountBalance',
    initialState,
    reducers: {
        setUSDBalance: (state, action) => {
            state.balance.usdBalance = action.payload
        },
        setLBPBalance: (state, action) => {
            state.balance.lbpBalance = action.payload
        },
        setAvailableUsdBalance: (state, action) => {
            state.availableSalesAndBalance.availableUsdBalance = action.payload
        },
        setAvailableLbpBalance: (state, action) => {
            state.availableSalesAndBalance.availableLbpBalance = action.payload
        }
    },
});

export const { setUSDBalance, setLBPBalance, setAvailableUsdBalance, setAvailableLbpBalance } = accountBalanceSlice.actions;
export default accountBalanceSlice.reducer;
